/** PURE_IMPORTS_START .._.._Observable,.._.._observable_fromPromise PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { fromPromise as staticFromPromise } from '../../observable/fromPromise';
Observable.fromPromise = staticFromPromise;
//# sourceMappingURL=fromPromise.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/observable/fromPromise.js
// module id = ./node_modules/rxjs/_esm5/add/observable/fromPromise.js
// module chunks = vendor